<template>
  <transition name="banner-slide">
    <div v-if="visible" class="notif-banner">

      <!-- Icône -->
      <div class="notif-banner__icon">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
          <line x1="12" y1="2" x2="12" y2="2.01"/>
        </svg>
      </div>

      <!-- Texte -->
      <div class="notif-banner__text">
        <span class="notif-banner__title">Restez informé en temps réel</span>
        <span class="notif-banner__sub">Recevez vos messages et alertes même lorsque l'onglet est fermé.</span>
      </div>

      <!-- Boutons -->
      <div class="notif-banner__actions">
        <button class="notif-banner__btn--later"  @click="remettre">Plus tard</button>
        <button class="notif-banner__btn--enable" @click="activer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="margin-right:5px">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
          </svg>
          Activer
        </button>
      </div>

      <!-- Fermer -->
      <button class="notif-banner__close" @click="remettre" aria-label="Fermer">✕</button>

    </div>
  </transition>
</template>

<script>
export default {
  name: 'NotifPermissionBanner',
  data: () => ({ visible: false }),

  mounted() {
    console.log('[NotifBanner] Permission actuelle:', Notification.permission)

    if (Notification.permission !== 'granted' && Notification.permission !== 'denied') {
      const ignoredUntil = localStorage.getItem('notif_ignored')
      const expire = ignoredUntil ? parseInt(ignoredUntil) : 0

      if (Date.now() > expire) {
        setTimeout(() => {
          this.visible = true
          console.log('[NotifBanner] Bannière affichée')
        }, 2500)
      } else {
        console.log('[NotifBanner] Ignoré jusqu\'à', new Date(expire).toLocaleString())
      }
    } else {
      console.log('[NotifBanner] Permission déjà:', Notification.permission)
    }
  },

  methods: {
    activer() {
      this.visible = false
      this.$emit('activer')
    },
    remettre() {
      this.visible = false
      localStorage.setItem('notif_ignored', String(Date.now() + 3 * 24 * 3600 * 1000))
    },
  },
}
</script>

<style scoped>
.notif-banner {
  position: fixed;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;

  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: nowrap;

  padding: 14px 16px 14px 16px;
  min-width: 320px;
  max-width: 580px;
  width: calc(100vw - 40px);

  background: #1c1c2e;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.35),
    0 2px 8px rgba(0, 0, 0, 0.2);
}

/* ── Icône ── */
.notif-banner__icon {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5b52ee, #8b5cf6);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ── Texte ── */
.notif-banner__text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.notif-banner__title {
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notif-banner__sub {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Boutons ── */
.notif-banner__actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.notif-banner__btn--later {
  padding: 7px 13px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
  white-space: nowrap;
}

.notif-banner__btn--later:hover {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.9);
}

.notif-banner__btn--enable {
  padding: 7px 15px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  background: linear-gradient(135deg, #5b52ee, #8b5cf6);
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  white-space: nowrap;
  transition: opacity 0.18s, transform 0.15s;
}

.notif-banner__btn--enable:hover {
  opacity: 0.88;
  transform: translateY(-1px);
}

/* ── Fermer ── */
.notif-banner__close {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.4);
  font-size: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: background 0.18s, color 0.18s;
  line-height: 1;
}

.notif-banner__close:hover {
  background: rgba(255, 80, 80, 0.25);
  color: #ff6b6b;
}

/* ── Animation ── */
.banner-slide-enter-active {
  animation: slide-up 0.38s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.banner-slide-leave-active {
  animation: slide-down 0.22s ease forwards;
}

@keyframes slide-up {
  from { opacity: 0; transform: translateX(-50%) translateY(24px) scale(0.97); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0)    scale(1);    }
}
@keyframes slide-down {
  from { opacity: 1; transform: translateX(-50%) translateY(0)    scale(1);    }
  to   { opacity: 0; transform: translateX(-50%) translateY(16px) scale(0.97); }
}

/* ── Mobile ── */
@media (max-width: 540px) {
  .notif-banner {
    bottom: 16px;
    padding: 12px 14px;
    gap: 10px;
    border-radius: 12px;
  }

  .notif-banner__sub {
    display: none;
  }

  .notif-banner__btn--later {
    display: none;
  }

  .notif-banner__icon {
    width: 36px;
    height: 36px;
  }

  .notif-banner__title {
    font-size: 12px;
  }
}
</style>